import React from 'react';
import './HeroSection.css';

const HeroSection: React.FC = () => (
  <section className="hero">
    <div className="hero-content">
      <h1>AI赋能审计，让信任更简单</h1>
      <p>覆盖风险预警、数据核查、报告生成全流程，助力审计机构数字化转型</p>
      <div className="hero-buttons">
        <button className="primary">立即体验</button>
        <button className="secondary">预约演示</button>
      </div>
    </div>
    <div className="hero-image">
      {/* 你可以将配图放在 public 目录下并引用 */}
      <img src="/logo192.png" alt="Dashboard" />
    </div>
  </section>
);

export default HeroSection; 